import { useState } from 'react';

export default function useHoverEvent({}: any) {
  const [isHover, setIsHover] = useState(false);

  function onMouseenter() {
    setIsHover(true);
  }

  function onMouseleave() {
    setIsHover(false);
  }

  return { isHover, onMouseenter, onMouseleave };
}
